module.exports = __webpack_public_path__ + "static/media/James Madison - 1808.4976a992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/James Madison - 1808.jpg
// module id = 505
// module chunks = 0